import createAreaCustomerForm from './createAreaFormModel';
const {
  formField: {
    // DATOS AREA 
    name,
    description,
    sucursal
  } 
} = createAreaCustomerForm;

export default {
  [name.name]: '',
  [description.name]: '',
  [sucursal.name]: '',
};

